<template>
  <div class="loader">
    <GFMP :styles="{ ...fmpStyles.rounded, width: '80px' }" />
    <ProductInlineLoader v-for="i in listCount" :key="i" />
  </div>
</template>

<script>
export default {
  name: 'product-inline-list-loader',
  components: {
    ProductInlineLoader: () => import('./product-inline-loader'),
  },
  props: {
    listCount: {
      type: Number,
      required: false,
      default: () => 3,
    },
  },
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '16px',
          minWidth: '16px',
        },
      },
    };
  },
  methods: {
    getRandomPercentage(min = 30, max = 100) {
      return `${min + Math.random() * (max - min)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

.loader {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
